export const styles = (theme) => {
  return {
    boxContainerTable: {
      borderRadius: '8px',
    },
    paperContainerTable: {
      width: '100%',
      borderRadius: '8px',
      boxShadow: theme.shadows[3],
    },
    removeBoxShadownContainerTable: {
      boxShadow: 'none',
    },
    tableContainerCashBankList: {
      height: 'calc(100vh - 260px)',
      minHeight: '275px',
      borderRadius: '8px',
    },
    iconButtonContainer: {
      '&:hover': {
        backgroundColor: 'rgba(222, 235, 255, 0.6)',
        '& svg': {
          fill: '#0052CC',
        },
      },
    },
    reject: {
      fontWeight: 500,
      color: '#B54708',
      backgroundColor: '#FFFAEB',
    },
    close: {
      fontWeight: 500,
      color: '#027A48',
      backgroundColor: '#ECFDF3',
    },
    expired: {
      fontWeight: 500,
      color: '#B42318',
      backgroundColor: '#FEF3F2',
    },
  };
};
